module.exports = __webpack_public_path__ + "img/A925.ab68ec1d.jpg";